import React from 'react';

import { GridTableCell } from '../../../shared/components/table-components';
import { getPriceOrDash } from '../../utils/getPriceOrDash/getPriceOrDash';

type PriceCellProps = {
  price: number;
};

const SubscriptionPriceCell = ({ price }: PriceCellProps) => {
  return <GridTableCell>{getPriceOrDash(price)}</GridTableCell>;
};

export { SubscriptionPriceCell, PriceCellProps };
